import React from 'react';

export interface DialogActionsProps extends React.HTMLAttributes<HTMLDivElement> {}

export const DialogActionsBase: React.FunctionComponent<DialogActionsProps> = props => (
    <div {...props} />
);
